export default __webpack_public_path__ + "static/a79543b6ed57516696a0665cf6659d3d.gif";